<template>
  <SysDialog v-model="DIALOG_ATIVO" content-class="b-radius-15px">
    <template #titulo>
      <div>
        <p class="ma-0 text-gray-900" @click="carregando = !carregando">Exportação Sankhya</p>
        <p class="ma-0 mt-n3 pl-1px font-12 text-gray-600 font-weight-regular" v-text="SUBTITULO_DIALOG" />
      </div>

      <v-spacer />

      <v-btn icon :disabled="carregando" @click="DIALOG_ATIVO = !DIALOG_ATIVO;$emit('fechar', {})">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>

    <template #default>
      <template v-if="!erro_exportacao.codigo">
        <Loading v-model="carregando" class="py-8" />

        <div v-if="!carregando" class="text-center">
          <template v-if="!produtosInvalidos.length">
            <SysFornecedorFabricanteAutocomplete
              v-if="config_integracao_sankhya_exibir_fornecedor"
              v-model="fornecedor_pedido"
              analise-grupo-fornecedores="N"
              :idfabricante="pedido.idfornecedor"
              :idpedido="pedido.idpedido"
              outlined
              label="Selecione o Fornecedor"
            />

            <SysFilialGrupoAutocomplete
              v-show="lista_filiais && lista_filiais.length > 1"
              v-model="filial_pedido"
              :id-grupo="pedido.grupo"
              label="Selecione a filial do pedido"
              class="mt-1"
              outlined
              auto-select-first
              @items="lista_filiais = $event"
            />

            <v-autocomplete
              label="Tipo de frete"
              v-model="tipos_frete.valor"
              :items="tipos_frete.itens"
              outlined
              append-icon="mdi-truck"
              :disabled="PEDIDO_JA_EXPORTADO"
            />
          </template>

          <template v-else>
            <v-icon size="80" color="red" class="my-3">mdi-file-alert</v-icon>
            <p class="ma-0 font-weight-medium text-red-900" v-text="`${produtosInvalidos.length} produtos inválidos para exportação`" />

            <div class="mx-auto text-left mt-5 mb-1" style="width: 260px">
              <ul>
                <li>Preço deve ser maior que 0.</li>
                <li>Quantidade deve ser maior que 0.</li>
              </ul>
            </div>
          </template>
        </div>
      </template>

      <template v-else>
        <div class="text-center py-4">
          <v-icon size="80" color="red" class="my-3">mdi-alert</v-icon>
          <p v-text="erro_exportacao.mensagem" class="text-red-900" />
        </div>
      </template>
    </template>

    <template #actions>
      <v-btn text :disabled="carregando || produtosInvalidos.length > 0" color="primary" @click="exportarPedido();setarErroDefault();">
        <template v-if="!carregando">{{ erro_exportacao.codigo ? 'tentar novamente' : 'ok, exportar' }}</template>
        <template v-else>...</template>
      </v-btn>
    </template>
  </SysDialog>
</template>

<script>
import SysDialog from "../../../padraoDeLayout/SysDialog.vue";
import {incluirPedido, alterarPedido} from "../../../../api/compras/ExportacaoPedidoSankhya.js";
import Loading from "./Loading.vue";
import {logout} from "../../../../helpers";
import SysFilialGrupoAutocomplete from "../../../utils/crud/SysFilialGrupoAutocomplete";
import SysFornecedorFabricanteAutocomplete from "@/components/utils/crud/SysFornecedorFabricanteAutocomplete.vue";

const STATUS_HTTP = {
  SERVIDOR_NAO_PROCESSANDO_REQUISICOES: 503
}

const codigos_erros = {
  inclusao_ou_alteracao_pedido: 1,
  delecao: 2,
}

const erro_exportacao_default = {
  codigo: null,
  mensagem: null
}

export default {
  name: "Index",
  components: {
    SysFornecedorFabricanteAutocomplete,
    SysFilialGrupoAutocomplete,
    Loading,
    SysDialog
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    pedido: {
      type: Object,
      required: true
    },
    produtos_pedido: {
      type: Array,
      default: () => ([])
    },
    resultados_exportacao: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    carregando: false,
    fornecedor_pedido: '',
    filial_pedido: '',
    tipos_frete: {
      itens: [
        {text: "CIF", value: "C"},
        {text: "FOB", value: "F"},
        {text: "Remetente", value: "R"},
        {text: "Destinatário", value: "D"}
      ],
      valor: "D"
    },
    erro_exportacao: Object.assign({}, erro_exportacao_default),
    lista_filiais: [],
    config_integracao_sankhya_exibir_fornecedor: localStorage.integracao_sankhya_exibir_fornecedor === 'S'
  }),
  computed: {
    DIALOG_ATIVO:  {
      get() {
        return this.modelValue;
      },
      set(novo_valor) {
        this.$emit("update:modelValue", novo_valor);
      }
    },
    produtosInvalidos() {
      const produto_invalido = produto => (produto.preco_custo <= 0 || produto.qtde_pedido <= 0)
      return this.produtos_pedido.filter(produto_invalido)
    },
    PEDIDO_JA_EXPORTADO() {
      return `${this.pedido.pedido_cli || ''}` !== '0';
    },
    SUBTITULO_DIALOG() {
      if (this.PEDIDO_JA_EXPORTADO) {
        return `Edição do pedido #${this.pedido.pedido_cli} no Sankhya`;
      }
      return `Exportação do pedido #${this.pedido.idpedido} com ${this.produtos_pedido.length} produtos`;
    },
    ATIVAR_DIALOG_COUNT() {
      return this.$store.getters['ExportacaoPedidoCompraParaERP/ativar_dialog_count'];
    }
  },
  watch: {
    DIALOG_ATIVO(valor) {
      if (!valor) {
        this.setarErroDefault();
      } else {
        if (this.PEDIDO_JA_EXPORTADO) {
          this.tipos_frete.valor = this.pedido.tipo_frete
        }
      }
    },
    resultados_exportacao() {},
    'resultados_exportacao.exclusao_produto': {
      handler(exclusao) {
        if (exclusao.sucesso) return;

        this.DIALOG_ATIVO = true;
        this.erro_exportacao.codigo = codigos_erros.delecao;
        this.erro_exportacao.mensagem = `Erro na exclusão do produto: ${exclusao.statusMessage}`;
      }
    },
    ATIVAR_DIALOG_COUNT() {
      if (localStorage.integracao_exportacao_compra_sankhya === 'S') {
        this.DIALOG_ATIVO = true;
      }
    }
  },
  methods: {
    setarErroDefault() {
      this.erro_exportacao = Object.assign({}, erro_exportacao_default);
      this.tipos_frete.valor = "D";
    },
    exportarPedido() {
      this.carregando = true;

      if (this.erro_exportacao.codigo === codigos_erros.delecao) {
        this.tentarDelecaoNovamente();
      } else if (this.PEDIDO_JA_EXPORTADO) {
        this.alterarPedido();
      } else {
        this.incluirPedido();
      }
    },
    tentarDelecaoNovamente() {
      // essa callbackFn é a função de deleção de produtos do carrinho
      const {callbackFn, payload} = this.resultados_exportacao.exclusao_produto;
      callbackFn(payload.produtos).finally(this.finalizarRequisicao)
    },
    alterarPedido() {
      alterarPedido(this.pedido.idpedido)
        .then(this.sucessoExportacao)
        .catch(this.falhaNaExportacao)
        .finally(this.finalizarRequisicao);
    },
    incluirPedido() {
      const parametros = {
        idpedido: this.pedido.idpedido,
        fornecedor_pedido: this.fornecedor_pedido,
        tipo_frete: this.tipos_frete.valor,
        filial_pedido: this.filial_pedido
      };

      incluirPedido(parametros)
        .then(this.sucessoExportacao)
        .catch(this.falhaNaExportacao)
        .finally(this.finalizarRequisicao);
    },
    sucessoExportacao(resposta) {
      localStorage.token = resposta.data.token;
      this.DIALOG_ATIVO = false;
      this.$emit("exportado-com-sucesso", {});
    },
    falhaNaExportacao(erro) {
      const {status, data} = erro.response;

      if (status === STATUS_HTTP.SERVIDOR_NAO_PROCESSANDO_REQUISICOES) {
        localStorage.token = data.token;
        this.erro_exportacao.codigo = codigos_erros.inclusao_ou_alteracao_pedido;
        this.erro_exportacao.mensagem = data.erro.statusMessage;
      } else {
        logout();
      }
    },
    finalizarRequisicao() {
      this.carregando = false;
    }
  }
}
</script>

<style scoped>

</style>
